import React, { useState, useEffect } from 'react';
import * as Switch from '@radix-ui/react-switch';
import { logger } from '../utils/logger';

export const DebugToggle: React.FC = () => {
  const [enabled, setEnabled] = useState(logger.isEnabled());

  useEffect(() => {
    setEnabled(logger.isEnabled());
  }, []);

  const handleToggle = (checked: boolean) => {
    setEnabled(checked);
    logger.setEnabled(checked);
  };

  return (
    <div className="flex items-center gap-2 bg-gray-800 rounded-lg px-3 py-2 border border-gray-700">
      <span className={`text-sm ${enabled ? 'text-white font-medium' : 'text-gray-400'}`}>
        Debug
      </span>
      <Switch.Root
        checked={enabled}
        onCheckedChange={handleToggle}
        className="w-9 h-5 bg-gray-700 rounded-full relative data-[state=checked]:bg-blue-500 transition-colors outline-none cursor-pointer"
      >
        <Switch.Thumb className="block w-4 h-4 bg-white rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[18px]" />
      </Switch.Root>
    </div>
  );
};
